import React from "react";

const FBIcon = () => {
	return (
		<svg
			width='36'
			height='37'
			viewBox='0 0 36 37'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<g clipPath='url(#clip0_42_55)'>
				<path
					d='M0 18.5C0 8.5589 8.0589 0.5 18 0.5C27.9411 0.5 36 8.5589 36 18.5C36 28.4411 27.9411 36.5 18 36.5C8.0589 36.5 0 28.4411 0 18.5Z'
					fill='#3B5998'
				/>
				<path
					d='M19.8761 29.0836V19.2907H22.5794L22.9377 15.916H19.8761L19.8808 14.2269C19.8808 13.3467 19.9644 12.8751 21.2286 12.8751H22.9186V9.5H20.2149C16.9673 9.5 15.8243 11.1371 15.8243 13.8902V15.9163H13.8V19.291H15.8243V29.0836H19.8761Z'
					fill='white'
				/>
			</g>
			<defs>
				<clipPath id='clip0_42_55'>
					<rect
						width='36'
						height='36'
						fill='white'
						transform='translate(0 0.5)'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default FBIcon;
